<template>
  <div class="ms-container full-width">
    <div class="contract-register">
      <inline-loader :loading="loading" v-if="loading" />
      <template v-else>
        <div class="contract-register-header">
          <i-button @click="exportTable" type="success">
            Экспорт таблицы
          </i-button>
        </div>
        <register-list :projects="contracts" :default-opened="['0']" />
      </template>
    </div>
  </div>
</template>

<script>
import InlineLoader from '@/components/loaders/inline-loader'
import RegisterList from '@/components/contracts-register/contracts-register-list'
import { mainUrl } from '@/config/urls'
import { downloadFile } from '@/utils'

export default {
  components: {
    InlineLoader,
    RegisterList
  },
  data () {
    return {
      loading: false,
      roadmap: [],
      contracts: [],
      token: this.$store.state.auth.token
    }
  },
  methods: {
    async getData () {
      try {
        this.loading = true

        const url = `page/contract_register?contract_id=${this.$route.params.id}`
        const data = await this.$store.dispatch('GET_REQUEST', { url })

        this.contracts = data

        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    exportTable () {
      const baseUrl = `page/contract_register?contract_id=${this.$route.params.id}`
      const url = `${mainUrl}/api/${baseUrl}&format=excel&access_token=${this.token}`

      downloadFile(url)
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style lang="less">
.contract-register {
  &-header {
    margin-bottom: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
